/* eslint-disable */
import {Collapse} from "antd";
import {useTranslation} from "react-i18next";
import TrendSettingsCommon
    from "../../../WellTree/components/MenuData/components/ControlPanel/components/TrendAnalysisModal/TrendSettingsCommon";
import TrendWells
    from "../../../WellTree/components/MenuData/components/ControlPanel/components/TrendAnalysisModal/TrendSettingsIndividual/TrendWells";
import React, {useEffect} from "react";
import {useStore} from "../../../../../../hooks/useStore";
import {observer} from "mobx-react-lite";

const TrendAnalysisWarningCollapse = observer(({
                                                   trendCommonSettingsData,
                                                   commonIndividual,
                                                   wellsData,
                                                   handleSearch,
                                                   trendIndividualSettingsData
                                               }) => {
    const {commonTrendParameterConstraintsStore} = useStore();

    useEffect(() => {
        commonTrendParameterConstraintsStore.setTrendCommonAnalysisSettings(trendCommonSettingsData);
        commonTrendParameterConstraintsStore.setWellsTrendIndividualAnalysisSettings(trendIndividualSettingsData);
    }, []);

    const {t} = useTranslation();
    const {Panel} = Collapse;

    return (
        <>
            <Collapse key={"common-settings-collapse"} accordion ghost>
                <Panel
                    header={t(commonIndividual[0])}
                    key={"common-settings-panel"}
                >
                    <TrendSettingsCommon
                        trendCommonSettingsData={commonTrendParameterConstraintsStore.getTrendCommonAnalysisSettings()}
                    />
                </Panel>
            </Collapse>

            <Collapse key={"individual-settings-collapse"} accordion ghost>
                <Panel
                    header={t(commonIndividual[1])}
                    key={"individual-settings-panel"}
                >
                    <TrendWells
                        wellsData={wellsData}
                        warningData={commonTrendParameterConstraintsStore.getWellsTrendIndividualAnalysisSettings()}
                        handleSearch={handleSearch}
                    />
                </Panel>
            </Collapse>
        </>
    );
});

export default TrendAnalysisWarningCollapse;
